module.exports = __webpack_public_path__ + "static/img/p3.146cc44c.png";